import React from 'react';
import Paper from '@material-ui/core/Paper';
import * as _filter from '../../helper/filter';
import DataTable from '../../components/View/DataTable';

type MailLogsProps = {
  objectCommonParentId?: number;
  customerId?: number;
  history: any;
  type: 'Customers' | 'MailMagazines';
}

function MailLogs({
  objectCommonParentId,
  customerId,
  history,
  type
}: MailLogsProps) {

  const targetName = (params: any) => {
    switch (type) {
      case 'MailMagazines':
        return (
          <div className="in-content">
            <div className="in-content">{params.data.customer_name}</div>
          </div>
        );
      default:
        return (
          <div className="in-content">
            <div className="in-content">【{params.data.displays.object_name}】</div>
            <div className="in-content">{params.data.target_name}</div>
          </div>
        );
    }
  }

  const showTbodyRow = (params: any): any => {
    return (
      <div className="data-table-inline-content">
        <div className="data-table-inline-content-text">
          <div className="in-content">{_filter.ShFilter(params.data.created, 'YMDHms')}</div>
          <div className="in-content">&lt; {params.data.sent_status} &gt;</div>
          <div className="in-content">
            {
              params.data.is_open &&
              <span><i className="far fa-envelope-open"></i>開封</span>
            }
            {
              params.data.is_open === false &&
              <span><i className="far fa-envelope"></i>未開封</span>
            }
          </div>
          {targetName(params)}
        </div>
      </div>
    );
  }

  const clickCell = (params: any) => {
    if (params.data !== undefined && params.data.id !== undefined) {
      history.push('/sh-mail-logs/' + params.data.id);
    }
  }

  const isObjectCommonParentId = objectCommonParentId === undefined ? '' : objectCommonParentId;

  return (
    <Paper className="content-2">
      <h2 className="h-2">メール配信履歴</h2>
      <DataTable
        checkbox={false}
        dataKey='shMailLogs'
        jsonPath={'sh-mail-logs/index/index.json'}
        urlQuery={false}
        handleClickCell={clickCell}
        funcTbodyRow={showTbodyRow}
        limit={5}
        size="small"
        defaultQueryValues={
          {
            object_common_parent_id: isObjectCommonParentId,
            customer_id: customerId
          }
        }
      />
    </Paper>
  )
}

export default MailLogs;